













import PopupEpisode2 from '@/views/templates/tenugui/PopupEpisode2.vue'

export default
  components: {
    PopupEpisode2
  }

  data: () ->
    message: [
      '吸水性・速乾性に優れているので、トレイルランニングはもちろん、ランニングやジョギングなど、運動量の多いアクティビティで大活躍。一般的なパイル地のタオルを水に濡らして絞った状態から約1時間放置すると、水分量が21%減少するのに対し、スポーツてぬぐいは最大74%も減少します。'
      '軽くてかさばらないので、携行性も抜群です。'
    ]

  methods: {
    closePopup: () ->
      @$emit('closePopup')
    add_point: (point) ->
      @$emit('addPoint', point)
  }
